export const SettingsIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
    <path d="M19.4 15a1.9 1.9 0 0 0 .38 2.09l.05.05a2.2 2.2 0 0 1-1.56 3.76 2.2 2.2 0 0 1-1.56-.65l-.05-.05a1.9 1.9 0 0 0-2.09-.38 1.9 1.9 0 0 0-1.16 1.73V21a2.2 2.2 0 0 1-4.4 0v-.07a1.9 1.9 0 0 0-1.16-1.73 1.9 1.9 0 0 0-2.09.38l-.05.05a2.2 2.2 0 0 1-3.12 0 2.2 2.2 0 0 1 0-3.12l.05-.05A1.9 1.9 0 0 0 4.6 15a1.9 1.9 0 0 0-1.73-1.16H2.8a2.2 2.2 0 0 1 0-4.4h.07A1.9 1.9 0 0 0 4.6 8.28a1.9 1.9 0 0 0-.38-2.09l-.05-.05a2.2 2.2 0 0 1 0-3.12 2.2 2.2 0 0 1 3.12 0l.05.05A1.9 1.9 0 0 0 9.44 2.7a1.9 1.9 0 0 0 1.16-1.73V.9a2.2 2.2 0 0 1 4.4 0v.07a1.9 1.9 0 0 0 1.16 1.73 1.9 1.9 0 0 0 2.09-.38l.05-.05a2.2 2.2 0 0 1 3.12 0 2.2 2.2 0 0 1 0 3.12l-.05.05a1.9 1.9 0 0 0-.38 2.09 1.9 1.9 0 0 0 1.73 1.16h.07a2.2 2.2 0 0 1 0 4.4h-.07A1.9 1.9 0 0 0 19.4 15z" />
  </svg>
);
